import React, { useEffect } from 'react';

const VersionChecker = () => {
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Usa PUBLIC_URL per supportare deploy in sottocartelle
        const publicUrl = process.env.PUBLIC_URL || '';
        const versionUrl = `${publicUrl}/version.json`;

        // Aggiungo timestamp per evitare caching della richiesta del file version.json
        const response = await fetch(`${versionUrl}?t=${new Date().getTime()}`, {  
          cache: 'no-store',
          headers: {
            'Pragma': 'no-cache',
            'Cache-Control': 'no-cache'
          }
        });
        
        if (!response.ok) return;
        
        const data = await response.json();
        const serverVersion = data.version;
        const localVersion = localStorage.getItem('app_version');

        console.log(`Version check: Server=${serverVersion}, Local=${localVersion}`);

        if (serverVersion && localVersion && serverVersion !== localVersion) {
          console.log(`New version found: ${serverVersion} (current: ${localVersion}). Clearing cache...`);
          
          // 1. Unregister all service workers
          if ('serviceWorker' in navigator) {
            const registrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of registrations) {
              // Non deregistriamo firebase-messaging-sw qui se vogliamo preservarlo,
              // ma se vogliamo un reset completo, meglio togliere tutto e lasciar ri-registrare al reload.
              // Dato che l'app ricarica, firebase.jsx verrà eseguito di nuovo e registrerà il SW.
              await registration.unregister();
            }
          }

          // 2. Clear all caches
          if ('caches' in window) {
            const keys = await caches.keys();
            await Promise.all(keys.map(key => caches.delete(key)));
          }

          // 3. Update version in localStorage
          localStorage.setItem('app_version', serverVersion);

          // 4. Force reload from server
          window.location.reload(true);
        } else if (!localVersion && serverVersion) {
            // First run or localStorage cleared
            console.log(`Setting initial version: ${serverVersion}`);
            localStorage.setItem('app_version', serverVersion);
        }
      } catch (error) {
        console.error('Error checking version:', error);
      }
    };

    // Check on mount
    checkVersion();

    // Check periodically (e.g., every 5 minutes)
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    
    const onFocus = () => checkVersion();
    window.addEventListener('focus', onFocus);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', onFocus);
    };
  }, []);

  return null;
};

export default VersionChecker;
